module.exports = __webpack_public_path__ + "img/spring-boot.27d77e56.png";